<template>
  <BaseNoticeItem :button-text="$t('View existing contract')" :button-url="existingHireUrl">
    <template #head>
      <strong>{{ $t('Contract cannot be accepted') }}</strong>
    </template>
    <template #body>
      <p>
        You cannot accept this contract, as you already have
        <a :href="existingHireUrl">an existing contract</a>
        with this client for the period {{ hire.startDate }} &ndash; {{ hire.endDate }}
        that overlaps with the dates of this contract.
      </p>
      <p>
        To accept this contract, you need to contact your client to adjust the contract dates so
        that they do not overlap with other contracts from that same client.
      </p>
    </template>
  </BaseNoticeItem>
</template>

<script setup>
import { computed } from 'vue'

import BaseNoticeItem from '@/components/BaseNoticeItem.vue'
import { useTranslation } from '@/composables/translation'
import { laravelNamedRoute } from '@/utils/laravelNamedRoutes'
import namedRoutes from '@/utils/laravelNamedRoutes.json'

const props = defineProps({
  complianceData: {
    type: Object,
    required: true,
  },
  hire: {
    type: Object,
    required: true,
  },
  isComplete: {
    type: Boolean,
    required: true,
  },
})

const { $t } = useTranslation()

const existingHireUrl = computed(() =>
  laravelNamedRoute(namedRoutes.messages.show, {
    id: props.complianceData.existingHire.thread_id,
  }),
)
</script>
